<app-global-loader></app-global-loader>
<app-ui-toast position="top-right"></app-ui-toast>
<router-outlet></router-outlet>
